import { useQuery } from 'react-query'

import { currencyQueryConfig } from '@webapp/core/query-configs/currency'

export const useCurrencySelect = () => {
  const { data, isFetching } = useQuery(currencyQueryConfig.listActive())

  return {
    data: {
      currencies: data || [],
    },
    states: {
      isFetching,
    },
  }
}
